var _circle, _circle2, _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#FF7FBF",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 10,
    r: 9.5,
    fill: "#FF7FBF",
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1959_47026",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2C18.4289 3.82441 20 6.72934 20 10.001C19.9999 13.2722 18.4284 16.1756 16 18C13.5716 16.1756 12.0001 13.2722 12 10.001C12 6.72934 13.5711 3.82441 16 2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C18.4289 3.82441 20 6.72934 20 10.001C19.9999 13.2722 18.4284 16.1756 16 18C13.5716 16.1756 12.0001 13.2722 12 10.001C12 6.72934 13.5711 3.82441 16 2Z",
    fill: "#FF7FBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2L16.6006 1.20043L16 0.749322L15.3994 1.20043L16 2ZM20 10.001L21 10.001V10.001H20ZM16 18L15.3994 18.7995L16 19.2508L16.6006 18.7995L16 18ZM12 10.001H11V10.001L12 10.001ZM16 2L15.3994 2.79957C17.5877 4.44322 19 7.05712 19 10.001H20H21C21 6.40156 19.2701 3.20561 16.6006 1.20043L16 2ZM20 10.001L19 10.001C18.9999 12.9442 17.5874 15.5567 15.3994 17.2005L16 18L16.6006 18.7995C19.2695 16.7945 20.9999 13.6002 21 10.001L20 10.001ZM16 18L16.6006 17.2005C14.4126 15.5567 13.0001 12.9442 13 10.001L12 10.001L11 10.001C11.0001 13.6002 12.7305 16.7945 15.3994 18.7995L16 18ZM12 10.001H13C13 7.05712 14.4123 4.44322 16.6006 2.79957L16 2L15.3994 1.20043C12.7299 3.20561 11 6.40156 11 10.001H12Z",
    fill: "black",
    mask: "url(#path-3-inside-1_1959_47026)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndIcon);
export default __webpack_public_path__ + "static/media/and-icon.b57794c97df2ee79b2cf8b2bc9fecadc.svg";
export { ForwardRef as ReactComponent };